<template>
  <DialogTemplate
    style="--max-mobile-height: var(--vh-3); min-width: clamp(1px, 64rem, 100vw)"
    contentStyle="padding:0; margin:0; overflow: hidden;"
  >
    <div
      v-if="onlyGwizSols"
      class="f-column flex-1"
      style="min-height: 0; min-width: 0"
    >
      <div class="d-flex">
        <div class="text-normal-large pa-4 weight_700 clr-primary">
          {{ $t('common.select_new_solution') }}
        </div>
      </div>
      <GmfSelektor
        ref="gmfselektor"
        :hasTableKeydown="true"
        :hasPreview="false"
        :instaApply="false"
        :namespace="tmpNamespace"
        :keepHistoryTree="keepHistoryTree"
        :routerParams="routerParams"
        class="bt-grey bb-grey gmf-dialog-form"
        style="--min-height: clamp(1px, 34em, var(--vh-6))"
      />
    </div>
    <TabBox
      v-else
      :key="libtabChoiceTab"
      class="flgmfslctr_tabbox pa-1"
      :options="libOptionChoice"
      :tab="libtabChoiceTab"
      translatePath="solutions"
      style="
        --tbbox-content-clr-back: var(--clr-black-0-3);
        --tbbox-content-padding: 0.5rem;
        --tbbox-overflow-y: hidden;
        --tbbox-overflow-x: hidden;
      "
      tabsStyle="
             --height: 2.5rem;
             --height-inner: 2.75rem;
             --tab-fnt-size: 1rem;
             --tab-radius: 8px;
             --inner-flex: 1;
             --padding-inner: 0 2.5rem 0 0;
            "
      :hasNamedTabSlot="true"
      :hasScrollRight="false"
      @click="
        item => {
          if (item.payload !== libtabChoiceTab) {
            item.fn()
          }
        }
      "
    >
      <template #tab_gwiz>
        <i class="mdi mdi-bookshelf text-large mr-2"></i>
        {{ $t(`solutions.gwiz`) }}
      </template>
      <template #tab_ai_sols>
        <i class="mdi mdi-folder-plus text-large mr-2"></i>
        {{ $t(`solutions.custom`) }}
      </template>
      <template #tab_ai_trees>
        <i class="mdi mdi-folder-cog text-large mr-2"></i>
        {{ $t(`solutions.custom_settings`) }}
      </template>
      <template #tab_ai_reports>
        <i class="mdi mdi-folder text-large mr-2"></i>
        {{ $t(`solutions.custom_reports`) }}
      </template>
      <template #default="{ tab }">
        <GmfSelektor
          v-if="currentTab === 'gwiz'"
          :ref="'gmf_selector'"
          :namespace="isStudy ? namespace : tmpNamespace"
          :channelId="channelId"
          :instaApply="isStudy"
          :hasPreview="!isStudy && keepHistoryTree"
          :hasTableKeydown="!isStudy ? false : true"
          :keepHistoryTree="keepHistoryTree"
          :routerParams="
            isStudy
              ? {
                  push: true,
                  replace: false,
                  saveLocally: true,
                }
              : routerParams
          "
          class="flex-1"
          style="--min-height: clamp(1px, 38rem, var(--vh-6))"
        />

        <SolfigrDashboard
          v-else
          ref="solform"
          :key="`${currentTab}_${solfigrBtnPortalName}`"
          class="flgmfslctr_gmf-selector"
          style="min-height: clamp(1px, 38rem, var(--vh-6))"
          :namespace="namespace"
          :tmpNamespace="!isStudy ? tmpNamespace : undefined"
          :channelId="channelId"
          :instaApply="isStudy"
          :confirmBtn="!isStudy"
          :routerParams="
            isStudy
              ? {
                  push: true,
                  replace: false,
                  saveLocally: true,
                }
              : routerParams
          "
          :hasSavedSolutions="currentTab === 'ai_sols'"
          :hasCustomReports="currentTab === 'ai_reports'"
          :hasSavedTrees="currentTab === 'ai_trees'"
          :hasPortalBtn="true"
          :btnPortalName="solfigrBtnPortalName"
          :selectedSavedTree="!isStudy ? selectedSavedTree : undefined"
          @update:savedtree="updateSavedTree"
          @click:confirm="apply"
        />
      </template>
    </TabBox>

    <template #dialog_actions>
      <div
        class="d-flex w-100"
        style="justify-content: flex-end"
      >
        <portal-target
          v-if="solfigrBtnPortalName"
          :key="solfigrBtnPortalName"
          :name="solfigrBtnPortalName"
        >
        </portal-target>
        <div
          v-if="showConfirmButton"
          data-tst="solutions_dialog_confirm_btn"
          class="gw_btn gw_btn-v1 gw_btn_primary weight_500 ml-2"
          @click="apply()"
        >
          {{ $t('btn.confirm') }}
        </div>
      </div>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import TabBox from '@/components/lib/TabBox'
import { SNK } from '@/helpers/helpers'

import GmfSelektor from '@/components/GameFormat/GmfSelektor/GmfSelektor'
import SolfigrDashboard from '@/components/ConfigureSolution/SolfigrDashboard'

import links_mix from '@/mixins/links_mix'
import { namespaces } from '@/helpers/constants'

export default {
  name: 'SolutionsDialog',
  components: {
    GmfSelektor,
    SolfigrDashboard,
    DialogTemplate,
    TabBox,
  },
  mixins: [links_mix],
  props: {
    dialog: Object,
  },
  data() {
    this.channelId = `floating_gmf_${Date.now()}`
    return {
      selectedSavedTree: null,
    }
  },
  methods: {
    updateSavedTree(item) {
      this.selectedSavedTree = item
    },
    persistPrefillGmf() {
      const query_gameformat = this.$store.getters[SNK('query_gameformat', this.namespace)]
      localStorage.setItem('prefill_query_gameformat', JSON.stringify(query_gameformat))
    },
    apply() {
      // TODO this is always hard to read - refactor and add comments
      if (
        this.applyMode === 'solfigrprefill' ||
        ['PracticeTrainer', 'PracticeDrills'].includes(this.$route.name)
      ) {
        const solutionType = this.$store.getters[SNK('query_solution_type', this.tmpNamespace)]
        if (solutionType === 'custom' && this.selectedSavedTree) {
          // could have been deleted on the table but still selected here
          const tableData =
            this.$store.getters.api_get_data('api_poker_saved_trees_table')?.results || []
          let selectedSavedTree = tableData.find(item => item.id === this.selectedSavedTree.id)
          selectedSavedTree = selectedSavedTree || tableData[0]

          if (selectedSavedTree) {
            this.$store.dispatch('api_poker_custom_user_trees', {
              id: this.selectedSavedTree.id,
              action: SNK('slfrm_handleSavedTreeApply', this.namespace),
              actionArgs: {
                mode: 'create_tree_for_trainer',
              },
            })
            this.$store.dispatch(`${this.namespace}/gamestate_reset_history`, {
              namespace: this.namespace,
            })
          }
        } else {
          // sync modules
          this.$store.dispatch('poker_copy_module', {
            from_namespace: this.tmpNamespace,
            to_namespace: this.namespace,
            queryGroup: 'router',
          })
          this.$store.dispatch('poker_copy_module', {
            from_namespace: this.tmpNamespace,
            to_namespace: this.namespace,
            queryGroup: 'gmf-selektor',
          })

          // setup router and recompute gmf_gameformat
          this.$store.dispatch('poker_copy_module', {
            from_namespace: this.tmpNamespace,
            to_namespace: this.namespace,
            queryGroup: 'gmf-selektor-to-router',
          })
        }

        // after all is copied persist the prefill gameformat
        if (this.applyMode === 'solfigrprefill') {
          this.persistPrefillGmf()
        }
      } else if (
        this.$route.name === 'StudySolutions' ||
        this.$route.name === 'PracticeRangeBuilder'
      ) {
        if (this.solutionType === 'custom') {
          this.$store.dispatch('poker_copy_module', {
            from_namespace: this.tmpNamespace,
            to_namespace: this.namespace,
            queryGroup: 'router',
          })

          if (this.libtab === 'ai_reports') {
            this.$refs.solform.applyReport({
              item: null,
              routerParams: {
                push: true,
                replace: false,
                saveLocally: true,
              },
            }) // all should be already set in the form
          } else {
            this.$refs.solform.apply({
              item: null,
              routerParams: {
                push: true,
                replace: false,
                saveLocally: true,
              },
            }) // all should be already set in the form
          }
        } else {
          this.$store.dispatch('poker_copy_module', {
            from_namespace: this.tmpNamespace,
            to_namespace: this.namespace,
            queryGroup: 'gmf-selektor',
          })

          if (!this.$refs.gmfselektor) return // sentry has this time to time
          this.$refs.gmfselektor.apply({
            namespace: this.namespace,
            routerParams: {
              push: true,
              replace: false,
              saveLocally: true,
            },
          })
        }
      } else {
        debugger
      }
      this.close()
    },
    resolveLibTab(namespace) {
      const solType = this.$store.getters[SNK('query_solution_type', namespace)]
      if (solType !== 'custom') return 'gwiz'

      return (
        this.$store.getters[SNK('query_gmfs_solution_tab', namespace)] ||
        this.libOptions.find(item => item.payload !== 'gwiz')?.payload ||
        'ai_sols'
      )
    },
    createLibOptions(config) {
      const { namespace, isStudy, useSwitchSolType, isTmp, allowedTabs = [] } = config

      const call = (payload, query) => ({
        payload,
        fn: () => {
          if (!isTmp || isStudy) {
            const args = {
              namespace,
              channelId: this.channelId,
              ...query,
            }
            const action = useSwitchSolType
              ? SNK('sol_switchSolTypeNEW', namespace)
              : SNK('sol_switchSolType', namespace)
            this.$store.dispatch(action, args)
          } else {
            this.$store.dispatch(SNK('router_update_query', namespace), {
              query,
              push: false,
              replace: false,
              saveLocally: false,
            })
          }
        },
      })

      const options = []

      if (allowedTabs.includes('gwiz')) {
        options.push(
          call(
            'gwiz',
            isStudy
              ? { gmfs_solution_tab: 'gwiz_sols', solType: 'gwiz' }
              : { solution_type: 'gwiz' },
          ),
        )
      }

      if (allowedTabs.includes('ai_sols')) {
        options.push(
          call('ai_sols', {
            gmfs_solution_tab: 'ai_sols',
            solType: 'custom',
            solution_type: 'custom',
          }),
        )
      }

      if (allowedTabs.includes('ai_trees')) {
        options.push(
          call('ai_trees', {
            gmfs_solution_tab: 'ai_trees',
            solution_type: 'custom',
          }),
        )
      }

      if (allowedTabs.includes('ai_reports')) {
        options.push(
          call('ai_reports', {
            gmfs_solution_tab: 'ai_reports',
            solType: 'custom',
          }),
        )
      }

      return options
    },
    close() {
      this.$store.dispatch('router_rm_dialog', this.dialog.dialog)
    },
  },
  computed: {
    isStudy() {
      return this.$route.name === 'StudySolutions' || this.$route.name === 'PracticeRangeBuilder'
    },
    currentTab() {
      return this.isStudy ? this.libtabStudy : this.libtab
    },
    libOptionChoice() {
      return this.isStudy ? this.libOptionsStudy : this.libOptions
    },
    libtabChoiceTab() {
      return this.isStudy ? this.libtabStudy : this.libtab
    },
    solfigrBtnPortalName() {
      const base = this.onlyGwizSols ? 'gwiz' : 'gwiz_custom'
      const tab = this.isStudy ? this.libtabStudy : this.libtab
      return `${base}_${tab}_custom_solution_btns`
    },
    tab() {
      return this.dialog.tab
    },
    namespace() {
      if (this.$route.name === 'StudySolutions' && this.dialog.applyMode !== 'solfigrprefill') {
        return {
          gwiz: namespaces.STUDY,
          ai_sols: namespaces.STUDY,
          ai_trees: namespaces.STUDY,
          ai_reports: namespaces.REPORTS,
        }[this.libtab]
      }
      return this.dialog.namespace || ''
    },
    tmpNamespace() {
      return this.dialog.tmpNamespace || ''
    },
    applyMode() {
      return this.dialog.applyMode || ''
    },
    onlyGwizSols() {
      return this.dialog.applyMode === 'solfigrprefill'
    },

    keepHistoryTree() {
      return this.$route.name === 'StudySolutions' || this.$route.name === 'PracticeRangeBuilder'
    },
    isTmp() {
      return this.tmpNamespace.includes('tmp')
    },
    // trainer
    solutionType() {
      return this.$store.getters[SNK('query_solution_type', this.tmpNamespace)] || 'gwiz'
    },
    libtab() {
      return this.resolveLibTab(this.tmpNamespace)
    },
    libtabStudy() {
      return this.resolveLibTab(this.namespace)
    },
    libOptions() {
      const allowedTabs = ['gwiz']

      if (['StudySolutions', 'PracticeRangeBuilder'].includes(this.$route.name)) {
        allowedTabs.push('ai_sols')
      }

      if (['PracticeTrainer', 'PracticeDrills'].includes(this.$route.name)) {
        allowedTabs.push('ai_trees')
      }

      if (this.$route.name === 'StudySolutions') {
        allowedTabs.push('ai_reports')
      }

      return this.createLibOptions({
        namespace: this.tmpNamespace,
        isStudy: false,
        isTmp: this.isTmp,
        allowedTabs,
      })
    },
    libOptionsStudy() {
      const allowedTabs = ['gwiz', 'ai_sols']

      if (this.$store.getters.sol_elite.can_use) {
        allowedTabs.push('ai_reports')
      }

      return this.createLibOptions({
        namespace: this.namespace,
        isStudy: true,
        useSwitchSolType: true,
        allowedTabs,
      })
    },
    routerParams() {
      const res = {
        push: !this.isTmp,
        replace: false,
        saveLocally: true,
        namespace: this.namespace,
      }
      return res
    },
    showConfirmButton() {
      const dialogsParam = this.$route.query.dialogs
      const count = typeof dialogsParam === 'string' ? dialogsParam.split(',').length : 0

      const show = this.isStudy ? count > 2 : this.solutionType !== 'custom'
      return show
    },
  },
}
</script>

<style lang="scss" scoped>
.gmf-dialog-form {
  padding: 1em;
}
@media (max-width: 1023px) {
  .gmf-dialog-form {
    padding: 1em 0;
  }
}
</style>
